import { ChatMessage } from "./ChatMessage";

export class Chat {
    id: string;
    userId: string;
    createdAt: Date;
    lastUsedAt: Date;
    messages: ChatMessage[];
}
